import React from "react";
import "./EffortList.scss";
import { Box, Button, Grid } from "@mui/material";
import { displayLatitudeLongitude } from "../../constants/Effort";
import { Link } from "react-router-dom";
import { getFieldLabel } from "../../constants/Helpers";

const EffortList = (props) => {
  return (
    <div className="EffortList" data-testid="EffortList">
      {props.trip.hasOwnProperty("images") &&
        props.trip.images.map(function (d, idx) {
          return (
            <div key={"effort_" + idx} className="margTop10">
              <Button
                style={{
                  width: "310px",
                  minWidth: "55vw",
                  maxWidth: "75vw",
                  backgroundColor: "lightgray",
                }}
              >
                <Link
                  style={{ width: "100%" }}
                  to={`${process.env.PUBLIC_URL}/effort-review`}
                  state={{
                    trip_id: props.trip.trip_id,
                    client_id: props.client_id,
                    effortNr: idx,
                  }}
                >
                  <Grid container>
                    <Grid item xs={12}>
                      <h3
                        style={{
                          borderBottom: "solid 1px #3f51b5",
                          width: "100%",
                        }}
                      >
                        Effort {idx + 1}
                      </h3>
                    </Grid>
                  </Grid>
                  <Box align="left">
                    <Grid container spacing={3}>
                      <Grid item xs={7}>
                        Gear Code:
                      </Grid>
                      <Grid item xs={5}>
                        {d.gearcode}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={7}>
                        Gear Quantity:
                      </Grid>
                      <Grid item xs={5}>
                        {d.gearqty ? d.gearqty : "N/A"}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={7}>
                        Gear Size:
                      </Grid>
                      <Grid item xs={5}>
                        {d.gearsize ? d.gearsize : "N/A"}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={7}>
                        Mesh / Ring Size:
                      </Grid>
                      <Grid item xs={5}>
                        {d.mesh_size ? d.mesh_size : "N/A"}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={7}>
                        Chart Area:
                      </Grid>
                      <Grid item xs={5}>
                        {d.chart_area ? d.chart_area : "N/A"}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={7}>
                        Number of Hauls:
                      </Grid>
                      <Grid item xs={5}>
                        {d.number_of_hauls ? d.number_of_hauls : "N/A"}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={7}>
                        Tow / Soak Time:
                      </Grid>
                      <Grid item xs={5}>
                        {d.tow_soak_time.hours
                          ? d.tow_soak_time.hours + ":" + d.tow_soak_time.minutes
                          : "N/A"}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={7}>
                        Fishing Depth:
                      </Grid>
                      <Grid item xs={5}>
                        {d.fishing_depth !== ""
                          ? d.fishing_depth + " " + d.fishing_depth_uom
                          : "N/A"}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={7}>
                        Latitude:
                      </Grid>
                      <Grid item xs={5}>
                        {displayLatitudeLongitude(
                          d.lat_long_format,
                          d.latitude_or_loran1
                        )}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={7}>
                        Longitude:
                      </Grid>
                      <Grid item xs={5}>
                        {displayLatitudeLongitude(
                          d.lat_long_format,
                          d.longitude_or_loran2
                        )}
                      </Grid>
                    </Grid>
                    {props.trip.report_type === "2" &&
                      ["PTLL", "PTCL"].includes(d.gearcode) && (
                        <>
                          {d.numTrapsInWater === "" ? null : (
                            <Grid container spacing={3}>
                              <Grid item xs={7}>
                                {getFieldLabel("effort", "numTrapsInWater") + ": "}
                              </Grid>
                              <Grid item xs={5}>
                                {d.numTrapsInWater}
                              </Grid>
                            </Grid>
                          )}

                          {d.numBuoyLines === "" ? null : (
                            <Grid container spacing={3}>
                              <Grid item xs={7}>
                                {getFieldLabel("effort", "numBuoyLines") + ": "}
                              </Grid>
                              <Grid item xs={5}>
                                {d.numBuoyLines}
                              </Grid>
                            </Grid>
                          )}

                          {d.numTrapsHauled === "" ? null : (
                            <Grid container spacing={3}>
                              <Grid item xs={7}>
                                {getFieldLabel("effort", "numTrapsHauled") + ": "}
                              </Grid>
                              <Grid item xs={5}>
                                {d.numTrapsHauled}
                              </Grid>
                            </Grid>
                          )}
                          {d.stringsHauled === "" ? null : (
                            <Grid container spacing={3}>
                              <Grid item xs={7}>
                                {getFieldLabel("effort", "stringsHauled") + ": "}
                              </Grid>
                              <Grid item xs={5}>
                                {d.stringsHauled}
                              </Grid>
                            </Grid>
                          )}

                          {d.numTrapsPerString === "" ? null : (
                            <Grid container spacing={3}>
                              <Grid item xs={7}>
                                {getFieldLabel("effort", "numTrapsPerString") + ": "}
                              </Grid>
                              <Grid item xs={5}>
                                {d.numTrapsPerString}
                              </Grid>
                            </Grid>
                          )}

                          {d.avgSoakTime === "" ? null : (
                            <Grid container spacing={3}>
                              <Grid item xs={7}>
                                {getFieldLabel("effort", "avgSoakTime") + ": "}
                              </Grid>
                              <Grid item xs={5}>
                                {`${d.avgSoakTime} hours`}
                              </Grid>
                            </Grid>
                          )}
                        </>
                      )}
                  </Box>
                </Link>
              </Button>
            </div>
          );
        })}
    </div>
  );
};

export default EffortList;
